/** @jsx h */

import { useRef, useEffect } from 'preact/hooks';
import ResultTeaser from './ResultTeaser';

const ResultContainer = ({
  list,
  listCount,
  searchType,
  restrictionFilters,
}) => {
  const firstNewResultRef = useRef(null);

  useEffect(() => {
    firstNewResultRef.current?.focus();
  }, [list.length]);

  return (
    <ul className={'search__results-items'}>
      {list
        && list.map((result, index) => (
          <li
            className="search__results-item"
            key={index}
            ref={
              list.length > listCount && index === list.length - listCount
                ? firstNewResultRef
                : undefined
            }
            tabIndex={
              list.length > listCount && index === list.length - listCount
                ? '-1'
                : ''
            }
          >
            <ResultTeaser
              result={result}
              searchType={searchType}
              restrictionFilters={restrictionFilters}
            />
          </li>
        ))}
    </ul>
  );
};

export default ResultContainer;
